import { mapState } from "vuex";

export default {
	template: `
	<div class="filter-container">
		<i @click="deleteFilter" class="material-icons btn-remove-filter">close</i>
		<v-select @change="onFilterSelection" v-model="filter" :items="availableFilters" item-text="label" item-value="value" label="Filter" single-line :menu-props="{contentClass: 'filter-menu-container'}">
			<template slot="item" slot-scope="data">
				<div class="filter-select-items-contaner">
					<span class="filter-value-label">{{ data.item.label }}</span>
				</div>
			</template>
		</v-select>

		<v-select @change="onOperationSelection" v-model="operator" :items="availableOperators" item-text="label" item-value="value" label="Operator" single-line :menu-props="{contentClass: 'filter-menu-container'}">
			<template slot="item" slot-scope="data">
				<div class="filter-select-items-contaner">
					<span class="filter-value-label">{{ data.item.label }}</span>
				</div>
			</template>
		</v-select>
		
		<v-menu
			v-if="filter == 'created_at'"
			v-model="dateMenu"
			:close-on-content-click="false"
			:nudge-right="40"
			transition="scale-transition"
			offset-y
			min-width="290px"
			content-class="filter-menu-container"
		>
			<template v-slot:activator="{ on, attrs }">
				<v-text-field
					v-model="date"
					label="Pick date"
					flat
					solo-inverted
					hide-details
					readonly
					v-bind="attrs"
					v-on="on"
					:id="'created-at-date-input'"
				></v-text-field>
			</template>
			<v-date-picker v-model="date" :max="maxDate" @input="onDateValueSelection"></v-date-picker>
		</v-menu>
		

		<v-select v-else @change="onValueSelection" v-model="value" :items="availableValues" item-text="label" item-value="value" label="Operator" single-line :menu-props="{contentClass: 'filter-menu-container'}">
			<template slot="selection" slot-scope="data">
				<div class="filter-select-items-contaner" v-if="filter == 'status' || filter == 'color'">
					<i class="material-icons" :style="{ color: data.item.styleColor }">{{ filter == 'status' ? 'fiber_manual_record' : 'label' }}</i>
					<span class="filter-value-label">{{ data.item.label }}</span>
				</div>
				<div class="filter-select-items-contaner" v-else-if="filter == 'rating'">
					<i class="material-icons">star_rate</i>
					<span class="filter-value-label">{{ data.item.value }}</span>
				</div>
				<div class="filter-select-items-contaner" v-else>
					<span class="filter-value-label">{{ data.item.label }}</span>
				</div>
			</template>
			<template slot="item" slot-scope="data">
				<div class="filter-select-items-contaner" v-if="filter == 'status' || filter == 'color'">
					<i class="material-icons" :style="{ color: data.item.styleColor }">{{ filter == 'status' ? 'fiber_manual_record' : 'label' }}</i>
					<span class="filter-value-label">{{ data.item.label }}</span>
				</div>
				<div class="filter-select-items-contaner" v-else-if="filter == 'rating'">
					<i v-for="index in data.item.value" :key="index" class="material-icons">star_rate</i>
				</div>
				<div class="filter-select-items-contaner" v-else>
					<span class="filter-value-label">{{ data.item.label }}</span>
				</div>
			</template>
		</v-select>
	</div>
    `,

	data() {
		return {
			filter: "color",
			operator: "==",
			value: "none",
			availableOperators: null,
			availableValues: null,
			date: new Date(),
			maxDate: new Date(),
			dateMenu: false,

			availableFilters: [
				{
					label: "Tag",
					value: "color",
				},
				{
					label: "Status",
					value: "status",
				},
				{
					label: "Rating",
					value: "rating",
				},
				{
					label: "Type",
					value: "type",
				},
				{
					label: "Created by",
					value: "created_by",
				},
				{
					label: "Created at",
					value: "created_at",
				},
			],

			operators: {
				color: [
					{
						label: "is",
						value: "==",
					},
					{
						label: "is not",
						value: "!==",
					},
				],
				status: [
					{
						label: "is",
						value: "==",
					},
					{
						label: "is not",
						value: "!==",
					},
				],
				rating: [
					{
						label: "equals",
						value: "==",
					},
					{
						label: "is not equal to",
						value: "!==",
					},
					{
						label: "is greater than or equal to",
						value: ">=",
					},
					{
						label: "is less than or equal to",
						value: "<=",
					},
					{
						label: "is less than",
						value: "<",
					},
					{
						label: "is greater than",
						value: ">",
					},
				],
				type: [
					{
						label: "is",
						value: "==",
					},
					{
						label: "is not",
						value: "!==",
					},
				],
				created_by: [
					{
						label: "is",
						value: "==",
					},
					{
						label: "is not",
						value: "!==",
					},
				],
				created_at: [
					{
						label: "is on",
						value: "==",
					},
					{
						label: "is not on",
						value: "!==",
					},
					{
						label: "is after",
						value: ">",
					},
					{
						label: "is before",
						value: "<",
					},
				],
			},

			values: {
				color: [
					{
						label: "None",
						value: "none",
						styleColor: "#989898",
					},
					{
						label: "Red",
						value: "red",
						styleColor: "red",
					},
					{
						label: "Orange",
						value: "orange",
						styleColor: "orange",
					},
					{
						label: "Yellow",
						value: "yellow",
						styleColor: "yellow",
					},
					{
						label: "Green",
						value: "green",
						styleColor: "green",
					},
					{
						label: "Blue",
						value: "blue",
						styleColor: "blue",
					},
					{
						label: "Pink",
						value: "pink",
						styleColor: "pink",
					},
					{
						label: "Purple",
						value: "purple",
						styleColor: "purple",
					},
				],
				rating: [
					{
						label: "1-star",
						value: 1,
					},
					{
						label: "2-star",
						value: 2,
					},
					{
						label: "3-star",
						value: 3,
					},
					{
						label: "4-star",
						value: 4,
					},
					{
						label: "5-star",
						value: 5,
					},
				],
				status: [
					{
						label: "No status",
						value: "no_status",
						styleColor: "#989898",
					},
					{
						label: "In progress",
						value: "in_progress",
						styleColor: "yellow",
					},
					{
						label: "Needs review",
						value: "need_review",
						styleColor: "blue",
					},
					{
						label: "Needs revision",
						value: "need_revision",
						styleColor: "orange",
					},
					{
						label: "Approved",
						value: "approved",
						styleColor: "green",
					},
				],
				type: [
					{
						label: "Image",
						value: "image",
					},
					{
						label: "Candidate",
						value: "candidate",
					},
					{
						label: "Match",
						value: "match",
					},
				],
			},
		};
	},

	props: {
		filterIndex: Number,
		filterId: String,
	},

	created() {
		this.maxDate.setDate(this.maxDate.getDate() + 1);
		this.maxDate = this.maxDate.toISOString().substr(0, 10);
		this.date.setUTCHours(0, 0, 0, 0);
		this.date = this.date.toISOString().substr(0, 10);

		this.availableOperators = this.operators.color;
		this.availableValues = this.values.color;
		this.$store.dispatch("Projects/addFilter", {
			filter: this.filter,
			operator: this.operator,
			value: this.value,
		});

		this.$store.dispatch("Projects/updateLastOpenProjectTree", this.$parent.$parent.$refs.projectTree);
	},

	computed: {
		...mapState("Projects", ["tags"]),
	},

	methods: {
		onFilterSelection() {
			this.availableOperators = this.operators[this.filter];
			this.operator = this.availableOperators[0].value;

			if (this.filter == "created_by") {
				let data = [];
				this.$store.state.Projects.project.users.forEach(user =>
					data.push({
						label: user.name,
						value: user.id,
					})
				);
				this.availableValues = data;
				this.value = this.availableValues[0].value;
			} else if (this.filter == "created_at") {
				this.value = this.date;
			} else {
				this.availableValues = this.values[this.filter];
				this.value = this.availableValues[0].value;
			}

			this.updateFilter();
		},
		onOperationSelection() {
			this.updateFilter();
		},
		onValueSelection() {
			this.updateFilter();
		},
		onDateValueSelection() {
			this.dateMenu = false;
			this.value = this.date;
			this.updateFilter();
		},
		updateFilter() {
			this.$store.dispatch("Projects/updateFilter", {
				index: this.filterIndex,
				data: {
					filter: this.filter,
					operator: this.operator,
					value: this.value,
				},
			});
		},
		deleteFilter() {
			this.$store.dispatch("Projects/deleteFilter", this.filterIndex);
			this.$store.dispatch("Projects/updateLastOpenProjectTree", this.$parent.$parent.$refs.projectTree);
			this.$emit("deleted", this.filterId);
		},
	},
};
